<div class="full-width py-3 px-4 fx-gap-20" fxLayout="column" fxLayoutAlign="start start">
  <div class="full-width mb-0" fxLayout="row" fxLayoutAlign="end center">
    <button class="button-close-top" mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="full-width" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="20px" fxFlexOffset="10px"  *ngIf="!otpMode">
    <div class="full-width" fxLayout="row" fxLayoutAlign="space-between center">
      <div class="title-default">Update Banking Details</div>
    </div>

    <div class="fx-col-w-100 fx-gap-30">
      <form [formGroup]="paymentMethodForm" class="full-width" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="20px">

        <div class="full-width" fxLayout="column" fxLayoutGap="7px">
          <span class="body-3-default">Account holder name</span>
          <mat-form-field appearance="outline" class="custom-text-field" floatLabel="always" style="width: 100%;">
            <input matInput type="text" formControlName="accountName"/>
            <mat-error *ngIf="paymentMethodForm.get('accountName')!.hasError('required')">
              Name is required
            </mat-error>
          </mat-form-field>
        </div>

        <div class="full-width" fxLayout="column" fxLayoutGap="7px">
          <span class="body-3-default">Bank Account Type</span>
          <mat-form-field class="custom-select-field" appearance="outline" style="width: 100%;">
            <mat-select class="custom-select-field-value" placeholder="Select" formControlName="bankAccountType">
              <mat-option class="custom-select-field-option">--</mat-option>
              <mat-option *ngFor="let type of bankAccountTypes" [value]="type.code" class="custom-select-field-option">
                {{type.type}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="paymentMethodForm.get('bankAccountType')!.hasError('required')">
              Bank account type is required
            </mat-error>
          </mat-form-field>
        </div>

        <div *ngIf="paymentMethodsOpts" class="full-width" fxLayout="column" fxLayoutGap="7px">
          <span class="body-3-default">Bank Name</span>
          <mat-form-field class="custom-select-field" appearance="outline" style="width: 100%;">
            <mat-select class="custom-select-field-value" placeholder="Select" formControlName="branchCode">
              <mat-option class="custom-select-field-option">--</mat-option>
              <mat-option *ngFor="let bank of bankOptions" [value]="bank.centralBranchCode"
                          class="custom-select-field-option">
                {{bank.bankName}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="paymentMethodForm.get('branchCode')!.hasError('required')">
              A Bank name is required
            </mat-error>
          </mat-form-field>
        </div>

        <div class="full-width" fxLayout="column" fxLayoutGap="7px">
          <span class="body-3-default">Account number</span>
          <mat-form-field appearance="outline" class="custom-text-field" floatLabel="always" style="width: 100%;">
            <input matInput type="text" formControlName="bankAccountNumber"/>
            <mat-error *ngIf="paymentMethodForm.get('bankAccountNumber')!.hasError('required')">
              Account number is required
            </mat-error>
          </mat-form-field>
        </div>

        <div *ngIf="paymentMethodsOpts" class="full-width" fxLayout="column" fxLayoutGap="7px">
          <span class="body-3-default">Payment type</span>
          <mat-form-field class="custom-select-field" appearance="outline" style="width: 100%;">
            <mat-select class="custom-select-field-value" placeholder="Select" [(value)]="selectedPaymentMethod"
                        formControlName="methodType">
              <mat-option *ngFor="let type of paymentMethodsOpts" [value]="type.typeCode"
                          class="custom-select-field-option">
                {{type.typeName}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="paymentMethodForm.get('methodType')!.hasError('required')">
              A Payment type is required
            </mat-error>
          </mat-form-field>
        </div>
      </form>

      <div fxFlexAlign="end">
        <button (click)="validateBankAccountDetails()" [disabled]="loading || paymentMethodForm.invalid" class="button-primary" mat-flat-button>
          <div class="button-text">{{ loading ? 'Working...' : 'Submit'}}</div>
          <mat-icon *ngIf="loading">
            <mat-spinner diameter="20"></mat-spinner>
          </mat-icon>
        </button>
      </div>

    </div>
  </div>

<!--  ********* OTP MODE ********* -->
  <div class="full-width" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="20px" *ngIf="otpMode">
    <div class="fx-col full-width" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="15px">
      <div class="title-default"> Please verify changes to your banking details</div>
      <div class="subtitle-default"> We have sent a One Time Pin to {{email}}</div>
    </div>

    <div fxFlexOffset="20px"></div>

    <div class="fx-row-w-100">
      <div class="p-10 full-width" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="15px">
        <div class="otp-text" fxFlexOffset="10px" fxFlexOffset.gt-sm="15px">
          <ng-otp-input
            #ngOtpInput
            (onInputChange)="onOtpChange($event)"
            [config]="{
              length: 4,
              allowNumbersOnly: true,
              containerClass: 'otp-wrapper-element',
              inputClass: 'otp-input-element'
            }"
          ></ng-otp-input>
        </div>
        <mat-error *ngIf="errMessage">{{ errMessage }}</mat-error>

        <div class="" fxFlexOffset="30px" fxFlexOffset.gt-sm="30px" fxLayoutGap="20px">
          <button (click)="verifyBankingDetailsOTP()" [disabled]="loading || len < 4" class="button-primary" mat-flat-button
                  style="width: 200px">
            <div class="button-text">{{ loading ? 'Working...' : 'Verify'}}</div>
            <mat-icon *ngIf="loading">
              <mat-spinner diameter="20"></mat-spinner>
            </mat-icon>
          </button>
        </div>

        <div class="text-center" fxFlexOffset.gt-sm="15px">
          Didn’t receive an OTP?
          <a (click)="!loading ? onResendOTP() : null" [routerLink]="" class="link-text btn-cursor">Resend OTP.</a>
        </div>
      </div>
    </div>
  </div>
</div>


